/**
 * GEN-3152 — para onde vai o "Abrir registro" de um vínculo do Kanban 2.0, quando o destino é uma PÁGINA.
 *
 * Certidão e conta corrente NÃO passam por aqui: elas abrem o modal de histórico SOBRE o kanban (r7) — o
 * comportamento do kanban legado. Se ganhassem rota, o CTA voltaria a jogar o usuário na listagem geral,
 * que é a regressão que a r7 corrigiu.
 *
 * Por que num módulo próprio (r11): a Caixa Postal precisa da MESMA constante de query param para ler o
 * deep link, e importá-la de `TaxKanbanV2` arrastaria os dois modais de histórico (componentes pesados
 * das telas de produto) para dentro do bundle da Caixa Postal. Este arquivo não tem dependência nenhuma.
 */

/** Query param que leva o guid da mensagem para a página da Caixa Postal. */
export const PARAM_MENSAGEM_DTE = "mensagem";

/**
 * GEN-3167 — caminho da ATIVIDADE dentro do host (sentido contrário ao `rotaDoRegistro`: daqui a
 * tela de produto abre o card do Kanban).
 *
 * O formato antigo (`/kanban-v2/quadros/:id?openCardId=:cardId`) continua sendo aceito pela lib, que
 * o converte para este; mas quem monta o link hoje já deve nascer no endereço canônico — é ele que
 * sobrevive ao F5 e pode ser copiado para outra pessoa.
 */
export const atividadeK2Path = (boardId: string, cardId: string): string =>
  `/kanban-v2/quadros/${encodeURIComponent(boardId)}/cards/${encodeURIComponent(cardId)}`;

const ROTA_DO_PRODUTO: Record<string, string> = {
  caixaPostal: "/caixa-postal",
  empresa: "/empresas",
  baseCadastral: "/empresas",
  pessoaFisica: "/pessoa-fisica",
  procuracao: "/credenciais",
  credencial: "/credenciais",
  usuario: "/usuarios",
};

/**
 * Rota do host para o registro, ou `null` quando o tipo não tem página de destino.
 *
 * A Caixa Postal leva o guid: sem ele o usuário desembarcava na listagem e tinha que caçar a mensagem no
 * meio de centenas. O destino continua sendo a PÁGINA — é lá que vivem o 2FA e a confirmação de ciência.
 */
export const rotaDoRegistro = (relationTypeKey: string, externalId?: string): string | null => {
  const rota = ROTA_DO_PRODUTO[relationTypeKey];
  if (!rota) return null;
  if (relationTypeKey === "caixaPostal" && externalId) {
    return `${rota}?${PARAM_MENSAGEM_DTE}=${encodeURIComponent(externalId)}`;
  }
  return rota;
};
